// Utility function to handle smooth scrolling
export const scrollToSection = (id: string, options?: { offset?: number }) => {
  const element = document.getElementById(id);
  const offset = options?.offset || 0;

  if (element) {
    const elementPosition = element.getBoundingClientRect().top;
    const offsetPosition = elementPosition + window.pageYOffset - offset;

    window.scrollTo({
      top: offsetPosition,
      behavior: "smooth"
    });
  } else {
    // If element not found (likely a page link), scroll to top
    window.scrollTo({
      top: 0,
      behavior: "smooth"
    });
  }
};
